import { inject as service } from '@ember/service';
import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
import { getChannelsCustomAttributeDefinitionOptionLabels, getChannelsCustomAttributeDefinitionLabels } from '@square/dashboard-items-data/utils/channels-custom-attribute-labels';
import { SOURCE_APPLICATION_NAME } from '@square/dashboard-items-data/models/connect/custom-attribute-definition/source-application';
export default CatalogObjectSerializer.extend({
  intl: service(),
  normalize(type, payload) {
    const normalized = this._super(type, payload);
    this._translateChannelsCustomAttributes(normalized);
    return normalized;
  },
  // Custom attribute definitions set by the channels team need to be translated.
  // This method is used to intercept these custom attribute definitions and overwrite the following with their internationalized
  // versions:
  // - Custom attribute names
  // - Custom attribute option names
  // - Name of the application that sets the custom attribute
  //
  // Translating these custom attribute below won't break the existing logic to save a changed custom attribute value for two reasons:
  // 1- Channels Custom Attributes have seller_visibility="SELLER_VISIBILITY_READ_WRITE_VALUES", meaning sellers can't modify
  //    the said custom attributes. So the name of the Channels custom attribute will never change.
  // 2- Write logic for updating fields that are type="SELECTION" do not use option.name to pass
  //    the new values to the backend, instead it uses a unique identifier called "string_value" which this method
  //    does not overwrite.
  _translateChannelsCustomAttributes(normalized) {
    const {
      customAttributeDefinitionData
    } = normalized.data.attributes;
    const belongsToChannelsCustomAttribute = customAttributeDefinitionData?.sourceApplication?.name === SOURCE_APPLICATION_NAME.CHANNELS;
    if (belongsToChannelsCustomAttribute) {
      // Translate custom attribute option names
      customAttributeDefinitionData?.selectionConfig?.allowedSelections?.forEach(selection => {
        selection.name = getChannelsCustomAttributeDefinitionOptionLabels(selection.name, this.intl);
      });
      // Translate custom attribute names
      customAttributeDefinitionData.name = getChannelsCustomAttributeDefinitionLabels(customAttributeDefinitionData.name, this.intl);

      // Translate name of the application that sets the custom attribute
      customAttributeDefinitionData.sourceApplication.name = this.intl.t('items.channels.customAttributes.sourceAppName');
    }
  }
});